import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { getAllEnrolledStudent, deleteEnquiry, verifyStudent } from "../../services/getAdminApi";
import "../../styles/RegisterStudentList.css";
import { FaTrash } from "react-icons/fa"; // Using FontAwesome for delete icon



const EnrolledStudents = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [verifying, setVerifying] = useState({});
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await getAllEnrolledStudent();
        if (response?.data?.data) {
          setStudents(response.data.data); 
        } else {
          Swal.fire("Error", "Failed to fetch students data.", "error");
        }
      } catch (error) {
        console.error("Error fetching students:", error);
        Swal.fire("Error", "An error occurred while fetching the students.", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, []);

  const handleSort = () => {
    const sortedData = [...students].sort((a, b) => {
      return sortOrder === "asc"
        ? new Date(a.created_at) - new Date(b.created_at)
        : new Date(b.created_at) - new Date(a.created_at);
    });
    setStudents(sortedData);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const handleDelete = (index, studentId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Call the API to delete the student from the backend
          const deletedEnquiry = await deleteEnquiry(studentId);

          // If deletion is successful, update the UI
          if (deletedEnquiry) {
            setStudents((prev) => prev.filter((_, i) => i !== index)); // Remove from state
            Swal.fire('Deleted!', 'The student has been removed.', 'success');
          }
        } catch (error) {
          Swal.fire('Error!', 'Failed to delete the student.', 'error');
        }
      }
    });
  };
  
  
  return (
    <div>
      <div className="dashboard-heading-div">
        <p>Enrolled Students</p>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : students.length === 0 ? (
        <p>No students found.</p>
      ) : (
        <div className="table-container-registered-students">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Gender</th>
                <th>Nationality</th>
                <th>City</th>
                <th>
                  Date & Time&nbsp;&nbsp;
                  <button onClick={handleSort}>
                    <i className="bx bxs-sort-alt" style={{ fontSize: "1rem" }}></i>
                  </button>
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {students.map((student) => (
                <tr key={student.id}>
                  <td>{student.id}</td>
                  <td>{student.first_name}</td>
                  <td>{student.last_name}</td>
                  <td>{student.email}</td>
                  <td>{student.mobile}</td>
                  <td>{student.gender}</td>
                  <td>{student.nationality}</td>
                  <td>{student.city}</td>
                  <td>{new Date(student.created_at).toLocaleString()}</td>
                  <td>
                    <button className="delete-btn" onClick={() => handleDelete(student.id)}>
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EnrolledStudents;
